import { render, staticRenderFns } from "./DialogLink.vue?vue&type=template&id=5e9637fd&scoped=true&"
import script from "./DialogLink.vue?vue&type=script&lang=js&"
export * from "./DialogLink.vue?vue&type=script&lang=js&"
import style0 from "./DialogLink.vue?vue&type=style&index=0&id=5e9637fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9637fd",
  null
  
)

export default component.exports